import React from 'react';
import { AritoIcon, AritoFormV2, BottomActionBarV2, DialogV2, HeaderTabsV2 } from '@/components/custom/erp';
import { usePhieuXuatDieuChuyenContext } from '../../context';
import { SearchFormValues, searchSchema } from '../../schema';

import { BasicInfoTab } from './BasicInfoTab';
import { DetailTab } from './DetailTab';

interface SearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSearch: (data: SearchFormValues) => void;
  initialData?: SearchFormValues;
}

export const SearchDialog: React.FC<SearchDialogProps> = ({ open, onClose, onSearch, initialData }) => {
  const { searchFields } = usePhieuXuatDieuChuyenContext();

  const handleSubmit = (data: SearchFormValues) => {
    const searchData = {
      ...data,
      ma_kho: searchFields.selectedWarehouse?.uuid,
      ma_vt: searchFields.selectedMaterial?.uuid,
      ma_khon: searchFields.selectedImportWarehouse?.uuid,
      ma_vi_tri: searchFields.selectedFromPosition?.uuid,
      ma_vi_trin: searchFields.selectedToPosition?.uuid,
      ma_lo: searchFields.selectedLot?.uuid,
      ma_unit: searchFields.selectedUnit?.uuid,
      ma_ngv: data.ma_ngv === 'ALL' ? '' : data.ma_ngv,
      ma_gd: data.ma_gd === 'ALL' ? '' : data.ma_gd,
      status: data.status === 'ALL' ? '' : data.status,
      user_id0: data.user_id0 === 'ALL' ? '' : data.user_id0
    };

    onSearch(searchData);
    onClose();
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title='Lọc phiếu xuất điều chuyển'
      maxWidth='xl'
      disableBackdropClose={false}
      disableEscapeKeyDown={true}
      titleIcon={<AritoIcon icon={12} />}
    >
      <AritoFormV2
        mode='search'
        hasAritoActionBar={false}
        schema={searchSchema}
        onSubmit={handleSubmit}
        initialData={initialData}
        className='w-[900px]'
        headerFields={
          <div className='max-h-[calc(100vh-150px)] overflow-y-auto'>
            <BasicInfoTab searchFields={searchFields} />

            <HeaderTabsV2
              tabs={[
                {
                  id: 'detail_tab',
                  label: 'Chi tiết',
                  component: <DetailTab searchFields={searchFields} />
                }
              ]}
            />
          </div>
        }
        bottomBar={<BottomActionBarV2 mode='search' onClose={onClose} />}
      />
    </DialogV2>
  );
};

export default SearchDialog;
